import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextIndentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-indent-left"} maskId="square-filled-radius-0-stroke-1-IconTextIndentLeft"><path fillRule="evenodd" clipRule="evenodd" d="M9 6H22V7H9V6ZM2 8.52841L6.86023 12L2 15.4716V8.52841ZM9 11.5H22V12.5H9V11.5ZM9 17H22V18H9V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTextIndentLeft;
